import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Breadcrumbs } from '..';
import { classes } from './Breadcrumbs.visual.st.css';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { simpleItemsExample, longTextItemsExample } from './exampleItems';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { breadcrumbsDriverFactory } from './Breadcrumbs.driver';

visualize('Breadcrumbs', () => {
  story('simple', () => {
    snap('default props', <Breadcrumbs items={simpleItemsExample} />);
    snap(
      'custom crumb text',
      <Breadcrumbs
        items={[
          { id: '0', value: 'This', href: '' },
          { id: '1', value: 'is a', href: '' },
          { id: '2', value: 'test', href: '' },
        ]}
      />,
    );
    snap(
      'rtl',
      <div dir="rtl">
        <TPAComponentsProvider value={{ rtl: true }}>
          <Breadcrumbs items={simpleItemsExample} />
        </TPAComponentsProvider>
        ,
      </div>,
    );
  });

  story('mobile ', () => {
    snap(
      'no trail',
      <TPAComponentsProvider value={{ mobile: true }}>
        <Breadcrumbs items={simpleItemsExample} />
      </TPAComponentsProvider>,
    );
    snap(
      'with trail',
      <TPAComponentsProvider value={{ mobile: true }}>
        <Breadcrumbs items={simpleItemsExample} showTrailOnMobileMode />
      </TPAComponentsProvider>,
    );
    snap(
      'rtl',
      <div dir="rtl">
        <TPAComponentsProvider value={{ mobile: true, rtl: true }}>
          <Breadcrumbs items={simpleItemsExample} />
        </TPAComponentsProvider>
        ,
      </div>,
    );
  });

  story('long text wrapping', () => {
    snap(
      'long text in constrained width',
      <div style={{ width: '300px' }}>
        <Breadcrumbs items={longTextItemsExample} />
      </div>,
    );
    snap(
      'long text mobile',
      <div style={{ width: '250px' }}>
        <TPAComponentsProvider value={{ mobile: true }}>
          <Breadcrumbs items={longTextItemsExample} />
        </TPAComponentsProvider>
      </div>,
    );
  });

  story('focus', () => {
    snap('focus', (done) => (
      <VisualAsync
        driverFactory={breadcrumbsDriverFactory}
        onDone={done}
        action={(driver) => driver.focusBreadcrumbAt(1)}
      >
        <Breadcrumbs onClick={() => {}} items={simpleItemsExample} />
      </VisualAsync>
    ));
  });
  story('style overrides', () => {
    snap('wst color override', () => (
      <Breadcrumbs items={simpleItemsExample} className={classes.wstColors} />
    ));
    snap('font', () => (
      <Breadcrumbs items={simpleItemsExample} className={classes.wstFont} />
    ));
    snap('tpa color overrides', () => (
      <Breadcrumbs items={simpleItemsExample} className={classes.tpaColors} />
    ));
  });
  story('hover', () => {
    const Hovered: React.FC<{ className?: string; onDone: () => void }> = ({
      className,
      onDone,
    }) => (
      <VisualAsync
        driverFactory={breadcrumbsDriverFactory}
        onDone={onDone}
        action={async (driver) => {
          await driver.setForceHoverAt(0, true);
        }}
      >
        <Breadcrumbs
          onClick={() => {}}
          items={simpleItemsExample}
          className={`${className || ''} ${classes.hoveredBreadcrumbs}`}
        />
      </VisualAsync>
    );

    snap('default hover opacity ', (done) => <Hovered onDone={done} />);
    snap('overriden hover opacity ', (done) => (
      <Hovered onDone={done} className={classes.customHoverOpacity} />
    ));
  });
});
